import { createContext, useContext } from 'react';
import type { AssertionOptions } from './types';

export type PaymentState =
  | 'LOADING'
  | 'AUTHENTICATING'
  | 'SUBMITTING_AUTH'
  | 'SUCCESS'
  | 'ERROR';

export interface PaymentData {
  readonly state: PaymentState;
  readonly paymentHash: string;
  readonly assertionOptions: AssertionOptions | null | undefined;
  readonly redirectUrlAfterPayment: string | null | undefined;
  readonly errorMessage: string;
}

export type PaymentAction =
  | {
    readonly type: 'ASSERTION_OPTIONS_RECEIVED';
    readonly assertionOptions: AssertionOptions;
    readonly redirectUrlAfterPayment: string | null | undefined;
  }
  | { readonly type: 'START_AUTHENTICATING' }
  | { readonly type: 'START_SUBMITTING_AUTH' }
  | { readonly type: 'AUTH_SUBMITTED' }
  | { readonly type: 'SET_ERROR'; readonly errorMessage: string }
  | { readonly type: 'RETRY' };

interface PaymentContextType {
  readonly data: PaymentData;
  readonly dispatch: (action: PaymentAction) => void;
}

const PaymentContext = createContext<PaymentContextType | null>(null);

export const PaymentProvider = PaymentContext.Provider;

export function usePayment(): PaymentContextType {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error('PaymentProvider not found');
  }
  return context;
}
